import {AnnotationBuilder} from './builders/AnnotationBuilder'

export const createAnnotation = AnnotationBuilder.create
